import { Injectable } from '@angular/core';
import { HttpExtendedService } from './http-extended.service';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';
import { Review } from 'src/models/review.model';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {

  private apiUrl: string;

  constructor(
    private http: HttpExtendedService,
    private config: ConfigService
  ) {
    this.apiUrl = config.config.goldenCommentUrl;
  }

  getReviews(): Observable<Review[]> {
    return this.http.get<Review[]>(this.apiUrl);
  }

  addReview(comment: Review): Observable<Review> {
    return this.http.post<Review>(this.apiUrl, comment);
  }

  updateReview(comment: Review): Observable<Review> {
    return this.http.put<Review>(this.apiUrl, comment);
  }

  deleteReview(comment: Review): Observable<Review> {
    return this.http.post<Review>(`${this.apiUrl}/delete`, comment);
  }

}
